<template>
  <div  >
    <Header></Header>
    <Title title="用户列表"></Title>
    <div class="contain_main">
      <div class="search" @keydown.enter="changepage(1)">
        <div class="search_item">
          <div class="item">
            <span>用户名:</span>
            <Input v-model="data.name" placeholder="请输入..." style="width:2rem"/>
          </div>
          <div class="item">
            <span>角色名称:</span>
            <Select v-model="data.group_id" style="width:1rem">
              <Option value="all">全部</Option>
              <Option v-for="item in list2" :key="item.id" :value="item.id">{{item.title}}</Option>
            </Select>
          </div>
          <div class="item">
            <span>账号状态:</span>
            <Select v-model="data.status" style="width:1rem">
              <Option value="all">全部</Option>
              <Option value="0">离职</Option>
              <Option value="1">在职</Option>
              <Option value="2">实习员工</Option>
              <Option value="3">冻结</Option>
              <!-- //         case 0:
                return "离职";
              case 1:
                return "在职";
              case 2:
                return "实习员工";
              case 3:
                return "冻结";   -->
            </Select>
          </div>
          <div class="item">
            <div class="button" @click="changepage(1)">搜索</div>
          </div>
          <div class="item">
            <div class="button" @click="showed=true;type=1">添加</div>
          </div>
        </div>
      </div>
      <div class="table">
        <table>
          <thead>
            <tr>
              <!-- <td>用户ID</td> -->
              <td>用户名</td>
              <td>登录账号</td>
              <td>角色</td>
              <td>部门</td>
              <td>状态</td>
              <td>添加日期</td>
              <td>操作</td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item,index) in list" :key="index">
              <!-- <td>{{item.id}}</td> -->
              <td>{{item.name}}</td>
              <td>{{item.username}}</td>
              <td>{{item.title}}</td>
              <td>{{item.departmentname}}</td>
              
              <td>{{item.status|status}}</td>
              <td>{{item.createtime|formatetime}}</td>
              <td>
                <button class="green" @click="edit(item)">编辑</button>
                <button
                  :class="item.status==3?'blue':'grep'"
                  @click="used(item.id,item.status==3?1:3)"
                >{{item.status==3?"启动":"禁用"}}</button>
                <button class="red" @click="del(item.id)">删除</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="page" style="text-align:right;margin-top:20px;">
        <Page
          :total="total"
          :current='data.page'
          @on-change="changepage"
          @on-page-size-change="changesize"
          show-sizer
          show-elevator
          show-total
          :page-size-opts="[5,10, 20,50]"
        />
      </div>
    </div>
    <usermanage v-if="showed" :type="type" :dataset="message" @success="success" @close="close"></usermanage>
  </div>
</template>
<script>
import Header from "../../components/header";
import Title from "../../components/title";
import {
  User_index,
  Auths_index,
  User_del,
  User_active
} from "../../assets/js/api.js";
import usermanage from "../../components/toast/usermanage";
export default {
  name: "testlist",
  data() {
    return {
      data: {
        // 名称	类型	必填	参数位置	默认值	备注
        name: "", //	string	false	普通参数		用户姓名
        group_id:'all', //	int	false	普通参数		用户组id
        status: 'all', //	int	false	普通参数		0禁用1正常
        page: 1,
        size: 10
      },
      showed: false,
      list: [],
      list2: [],
      total: null,
      type: 1,
      message: null
    };
  },
  mounted() {
    this.getlist();
    this.getlist2();
  },
  filters: {
    status(value) {
      switch (value) {
        //1在职、0离职、2实习员工3冻结
        case 0:
          return "离职";
        case 1:
          return "在职";
        case 2:
          return "实习员工";
        case 3:
          return "冻结";  
          
      }
    }
  },
  components: {
    Header,
    Title,
    usermanage
  },
  methods: {
    close() {
      this.showed = false;
    },
    success() {
      this.close();
      this.getlist();
    },
    changepage(data) {
      this.data.page = data;
      this.getlist();
    },
    changesize(data) {
      this.data.page = 1;
      this.data.size = data;
      this.getlist();
    },
    getlist() {
      var data = JSON.parse(JSON.stringify(this.data))
      if(this.data.group_id=='all'){
        data.group_id = ' '
      }
      if(this.data.status=='all'){
        data.status = ' '
      }
      User_index(data).then(res => {
        if (res.data.code == 200) {
          this.list = res.data.data.list;
          this.total = res.data.data.count;
          return 
        }
        this.$Notice.warning({ title: "信息提示", desc: res.data.message });
        this.list = [];
        this.total = 0;
      });
    },
    getlist2() {
      Auths_index(this.data).then(res => {
        if (res.data.code == 200) {
          this.list2 = res.data.data;
        }
      });
    },
    edit(data) {
      this.type = 2;
      this.message = data;
      this.showed = true;
    },
    used(data, act) {
      User_active({
        id: data,
        status: act
      }).then(res => {
        if (act == 0) {
          this.$Notice.success({ title: "成功提示", desc: "启用成功！" });
          this.getlist();
        } else {
          this.$Notice.success({ title: "成功提示", desc: "禁用成功！" });
          this.getlist();
        }
      });
    },
    del(data) {
      if (!confirm("确定删除该条信息？")) return;
      User_del({ id: data }).then(res => {
        if (res.data.code == 200) {
          this.$Notice.success({ title: "成功提示", desc: "删除成功！" });
          this.getlist();
          return;
        }
        this.$Notice.warning({ title: "信息提示", desc: res.data.message });
      });
    }
  }
};
</script>
<style lang="css" scoped>
/* 搜索栏样式------------------------------------------------------------------------------------------- */
.search {
  margin-top: 0.2rem;
  display: flex;
  color: #575e6b;
}
.search .search_item {
  display: flex;
}
.search .search_item .item {
  margin: 0 0.15rem;
}
.button {
  width: 0.9rem;
  height: 0.3rem;
  color: #fff;
  background: #4b51ff;
  line-height: 0.3rem;
  border-radius: 0.02rem;
  font-size: 0.14rem;
}
/* 表格栏目样式----------------------------------------------------------------------------------------------*/
.table {
  margin-top: 0.6rem;
  font-size: 0.14rem;
}
table {
  width: 100%;
}
thead tr {
  color: #a4acbf;
}
tbody tr {
  color: #707788;
}
tr {
  height: 0.6rem;
}
/*查看详情button-----------------------------------------------------------------------------------------------------------------*/
button {
  border-radius: 0.2rem;
  border: none;
  margin: 0 0.02rem;
  padding: 0.04rem 0.1rem;
  font-size: 0.14rem;
  outline: none;
}
button.blue {
  color: #25b3f9;
  background: #d3f3fc;
}
button.pri {
  color: #e037ff;
  background: #fadfff;
}
button.orange {
  color: #ff8d13;
  background: #ffe2c4;
}
button.green {
  color: #36cd68;
  background: #cffade;
}
button.red {
  color: #ff3a68;
  background: #ffd6de;
}
button.blue {
  color: #4ba2e9;
  background: #d5ebfd;
}
button.grep {
  color: #bbb;
  background: #eee;
}
</style>


// WEBPACK FOOTER //
// src/pages/system/managelist.vue